import { Component, Input, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import {ApiService} from "../../core/api/api.service";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {customerRole} from "../../core/access-roles/customer.role";

@Component({
    selector: 'bergh-fp-documents',
    templateUrl: './fp-documents.component.html',
    styleUrls: ['./fp-documents.component.scss'],
    standalone: false
})

export class FpDocumentsComponent implements OnInit {
  @Input() projectId: string;
  @Input() firePartitionId: string;
  showAllDocuments: boolean = false;
  allDocuments = []
  linkedDocuments = []
  isSealPage: boolean;
  isCustomer: boolean;
  constructor(
    private _router: Router,
    private _api: ApiService,
    private _toastr: ToastrService,
    private _accessControl: AccessControlService
  ) { }

  ngOnInit(): void {
    this.isCustomer = this._accessControl.getRoleCode() === customerRole.code;
    this.getDocuments()
    this.isSealPage = this._router.url.includes("afdichtingen")
  }

  getDocuments(){
    this._api.request("getProjectDocument", `${this.projectId}/document`).subscribe((result)=>{
      this.allDocuments = result
      this.linkedDocuments = this.allDocuments.filter((item) => item.linkedFirePartitionIds.includes(this.firePartitionId))
      this.allDocuments = this.allDocuments.map((item) => {
        item.linked = !!item.linkedFirePartitionIds.includes(this.firePartitionId);
        return item;
      })
    })
  }

  linkDocumentWithFirePartition(id){
    const firePartition = {
      "firePartitionIds": [this.firePartitionId]
    }
    this._api.request("linkFirePartition",
                      firePartition,
                      `${this.projectId}/document/${id}/link-firepartitions`)
                      .subscribe(() =>{
                        this._toastr.success("Succes")
                        this.getDocuments()
                      })
  }

  unlinkDocumentWithFirePartition(id){
    const firePartition = {
      "firePartitionIds": [this.firePartitionId]
    }
    this._api.request("unlinkFirePartition",
                      firePartition,
                      `${this.projectId}/document/${id}/unlink-firepartitions`)
                      .subscribe(() =>{
                        this._toastr.success("Succes")
                        this.getDocuments()
                      })
  }

}
